import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";

export function RequireAuth({ children, adminOnly = false }: { children: ReactNode; adminOnly?: boolean }) {
  const { session, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="boot">
        <span className="boot-dot" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (adminOnly && !isAdmin) {
    return <NotAdmin />;
  }

  return <>{children}</>;
}

function NotAdmin() {
  const { user, signOut } = useAuth();
  return (
    <main className="locked">
      <h1>Not authorised</h1>
      <p>
        {user?.email ?? "This account"} doesn't have admin access to the Alibi Marketing Agent.
        Ask Scott to grant the <code>admin</code> role.
      </p>
      <button onClick={signOut}>Sign out</button>
    </main>
  );
}
